import React, {ComponentType, useContext} from 'react';
import {BiLogger} from '../../services/biLogger/biLogger';
import {BiContext} from './BiProvider';

export function useBiLogger(): BiLogger {
  const logger = useContext(BiContext);
  if (!logger) {
    throw new Error('No Bi Logger');
  }
  return logger;
}

interface BiLoggerHocProps {
  biLogger: BiLogger;
}

export function withBiLogger<P extends {children?: React.ReactNode;}>(Component: React.ComponentType<P & BiLoggerHocProps>): React.FC<P> {
  const ComponentWithBiLogger: React.FC<P> = ({children, ...props}) => {
    const biLogger = useBiLogger();
    return (
      <Component biLogger={biLogger} {...(props as P)}>
        {children}
      </Component>
    );
  };

  ComponentWithBiLogger.displayName = `WithBiLogger${Component.displayName || Component.name || 'Component'}`;
  return ComponentWithBiLogger;
}
